import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import useFetch, { Provider } from "use-http";
import { createStore, StoreProvider } from "easy-peasy";
import model from "./store/model";

const store = createStore(model, { disableImmer: true });
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
const options = {
	cachePolicy: "no-cache"
};

ReactDOM.render(
	<StoreProvider store={store}>
		<Provider url={REACT_APP_API_URL} options={options}>
			<App />
		</Provider>
	</StoreProvider>
, document.getElementById("root"));